import { combineReducers } from 'redux';
import manufacturers from './reducer_manufacturers';
import chuckTypes from './reducer_chuckTypes';
import chuckSizes from './reducer_chuckSizes';
import chuckDetails from './reducer_chuckDetails';
import products from './reducer_products';
import shopParameters from './reducer_shop_parameters';
import pricingRequest from './reducer_pricingRequest';
import errors from './reducer_errors';

import { localizeReducer } from 'react-localize-redux';

const rootReducer = combineReducers({
  manufacturers,
  chuckTypes,
  chuckSizes,
  chuckDetails,
  shopParameters,
  products,
  pricingRequest,
  localize: localizeReducer,
  errors
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js